import Profile from "../../templates/Profile";
import MainProfileHeader from "../../molecules/MainProfileHeader";
import BannerFooter from "../../atoms/BannerFooter";
import DesplegableMenu from "../../organisms/DesplegableMenu";

export default function ModulesPage({ content }) {
  return (
    <>
      <Profile
        role="superAdmin"
        header={<MainProfileHeader />}
        navbar={<DesplegableMenu />}
        footer={<BannerFooter />}
        content={content}
      />
    </>
  );
}
